export class RegexExpression {
    public static readonly PasswordPattern = /.*/; // Accept any password format
    public static readonly NumberOnly = /^[0-9\b]+$/;
    public static readonly EmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    public static readonly PhonePattern = /^[0-9\b]+$/;
    public static readonly NamePattern = /^[a-zA-Z\s]+$/;
}